import { ReactNode } from 'react';
import { Button, Checkbox, Flex, Title } from '@mantine/core';
import { useIntlLight } from '../../../i18n';
import { useAppSettings } from '../../../../hooks/useAppSettings';
import useGlobalModal from '../../hooks/useGlobalModal';

export default function Notice({
  text,
  title,
  identifier,
}: {
  text: string | ReactNode;
  title?: string;
  identifier: string;
}) {
  const { disableNotice, enableNotice } = useAppSettings();
  const { t } = useIntlLight();
  const { close } = useGlobalModal();

  return (
    <>
      <Title order={3} mb="xl" pb="xs">
        {title}
      </Title>
      {typeof text === 'string' ? <p>{text}</p> : text}
      <Checkbox
        mt="md"
        label={t('declaration_addDeclaration_disableNotice')}
        onChange={event => {
          const json = localStorage.getItem('me');
          const me = json ? JSON.parse(json) : undefined;
          const isChecked = event.currentTarget.checked;

          if (isChecked) {
            disableNotice(identifier, me?.username);
          } else {
            enableNotice(identifier, me?.username);
          }
        }}
      />
      <Flex mt="21" sx={{ justifyContent: 'end' }}>
        <Button color="red" onClick={close}>
          {t('app.close')}
        </Button>
      </Flex>
    </>
  );
}
